// Affiliation
export const REFERRAL_COOKIE_LIFETIME = 30; // in days
export const REFERRAL_COMMISSION = 20; // in percent
export const REQUIRED_REFERRALS_FOR_PAYOUT = 2; // successful referrals

// Course
export const DEFAULT_CURRENCY = "PKR";

// Dashboard
export const DASHBOARD_LIST_QUANTITY = 20;

// Mock data
export const SHOW_MOCK_COUNT = true;
export const SHOW_MOCK_DATA = false;
export const MOCK_ENROLLMENTS_COUNT = 585;
export const MOCK_REVIEWS_COUNT = 117;
export const MOCK_AVERAGE_RATING = 4.8;

// Leaderboard
export const POINTS_PER_CHAPTER = 10;

// Media
export const BUNNY_PLAYBACK_URL_PREFIX = `https://${process.env.NEXT_PUBLIC_BUNNY_STREAM_PULL_ZONE}.b-cdn.net`;
export const MUX_PLAYBACK_URL_PREFIX = "https://stream.mux.com";
export const YOUTUBE_PLAYBACK_URL_PREFIX_V1 = "https://www.youtube.com";
export const YOUTUBE_PLAYBACK_URL_PREFIX_V2 = "https://youtu.be";
export const GOOGLE_DRIVE_PLAYBACK_URL_PREFIX = "https://drive.google.com/file/d";
export const WISTIA_PLAYBACK_URL_PREFIX = "https://home.wistia.com/medias";

// Navbar
export const NAVBAR_HEIGHT = 80;
export const ANNOUNCEMENT_BANNER_HEIGHT = 36;
export const SECTION_SCROLL_MARGIN = 116;

// Other
export const MAX_SLUG_CREATE_ATTEMPTS = 10;
export const DB_GENERAL_ERROR_MESSAGE = "A database operation failed.";
export const SEARCH_ENGINE_DESCRIPTION_LIMIT = 160;

export const TEACHER_EMAILS = ["hammadjaved9860@gmail.com", "asadjaved986@gmail.com", "asad007javed@gmail.com"];
export const STUDENT_TEST_EMAIL = "hammadjaved9860@gmail.com";

export const WHATSAPP_BUTTON_WHITELISTED_ROUTES = [
  "/",
  "/courses",
  "/course",
  "/affiliate-program",
  "/about",
  "/contact",
  "/privacy-policy",
];

export const METADATA_INDEX_BLACKLISTED_COURSE_SLUGS = [
  "cinematography-master-class",
  "e-commerce-master-class",
  "example",
  "figma-mastery",
  "generative-ai-masterclass",
  "nextjs-full-course",
  "pet-care",
  "web-development",
];

// Recycled

// 08 May 2025

// export const BUNNY_PLAYBACK_URL_PREFIX = "https://iframe.mediadelivery.net/";
// export const MUX_PLAYBACK_URL_PREFIX = "mux-playback-id:";
